/**
 * Human labels for signal kinds shown in the Progress surfaces' signals
 * breakdown. Pure logic shared by web and mobile: unknown kinds fall back to a
 * title-cased form of the kind so every real row stays visible.
 */
const SIGNAL_KIND_LABELS = {
    "nutrition.meal": "Meals",
    "nutrition.sodium_mg": "Sodium",
    "hydration.ml": "Hydration",
    "wearable.sleep": "Sleep",
    "wearable.nap": "Naps",
    "wearable.workout": "Workouts",
    "wearable.activity": "Daily activity",
    "wearable.hrv": "HRV",
    "wearable.rhr": "Resting heart rate",
    "wearable.stress": "Stress",
    "wearable.weight": "Weight",
    "wearable.glucose": "Glucose",
    "wearable.spo2": "Blood oxygen",
    "wearable.respiration": "Respiration",
    "wearable.skin_temp": "Skin temperature",
    "wearable.vo2max": "VO2 max",
    "wearable.bp.systolic": "Blood pressure",
    "wearable.bp.diastolic": "Blood pressure (diastolic)",
    "self_report.checkin": "Check-ins",
    "self_report.weight": "Weight logs",
    "self_report.glp1_dose": "Doses",
    "medication.dose": "Medication",
    "user.microstep_completed": "Microsteps completed",
    "user.microstep_added": "Microsteps added",
    "user.microstep_adjusted": "Microstep adjustments",
    "user.microstep_feedback": "Microstep feedback",
    "user.app_open": "App opens",
    "user.completion_moment": "Completion context",
    "user.feedback": "Feedback",
    "survey.pulse": "Wellbeing check-ins",
    "calendar.event": "Calendar events",
    "lab.hba1c": "Lab results",
    "environment.weather_today": "Weather",
    "environment.air_quality": "Air quality",
    "environment.pollen": "Pollen",
    "environment.uv": "UV",
    "environment.solar": "Daylight",
    "environment.location_bucket": "Location",
    "adherence.slippage_detected": "Slippage detected",
    "adherence.recovered": "Recoveries",
    "external.company_event": "Company events",
};
export function signalKindLabel(kind) {
    const known = SIGNAL_KIND_LABELS[kind];
    if (known)
        return known;
    return titleCaseKind(kind);
}
function titleCaseKind(kind) {
    const words = kind.replaceAll(".", " ").replaceAll("_", " ").trim().split(/\s+/);
    return words
        .map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
        .join(" ");
}
//# sourceMappingURL=signal-kind-labels.js.map